import { useRouter } from "next/router";
import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import { Carousel } from "react-responsive-carousel";
import { cn } from "../../lib/utils";
import CartStorage from "../../services/frontend/CartStorage";
import Basket from "../Cart/Basket";
import StaticInfoBanner from "../Infobanner/StaticInfoBanner";
import NavBar2 from "../NavBar2/NavBar2";
import SideNavDrawer from "../SideNavDrawer";
import { Skeleton } from "../Skeleton";
import SkeletonCard from "../SkeletonCard";
import styles from "./featured-home.module.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FeaturedCollectionWithProd from "./FeaturedCollectionWithProd";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useCollectionWithStoreProducts } from "./utils";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const FeaturedHome = ({
  theme,
  store,
  updateHomeActive,
  heroMedia,
  heroMediaImages,
  heroMediaType,
  heroTitle,
}) => {
  const [cart, setCart] = useState(CartStorage.getInitialCart());
  const [isCartInitialized, setIsCartInitialized] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [showSideNav, setShowSideNav] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const initialize = async () => {
      const initialCartData = await CartStorage.initializeCart();
      setCart(initialCartData);
      setIsCartInitialized(true);
    };
    initialize();
  }, []);

  const updateAndSaveCart = async (newCartData) => {
    setCart(newCartData);
    await CartStorage.saveCart(newCartData);
  };

  const updateAddedToCart = (productId, value) => {
    console.log(`FeaturedHome: Product ${productId} added status: ${value} (update logic needed)`);
  };

  const handleShowCart = (boolVal = false) => {
    setShowCart(boolVal);
  };

  const { data: collectionsData, loading: isCollectionsLoading } = useCollectionWithStoreProducts(
    store.id,
  );

  return (
    <>
      <StaticInfoBanner text={store?.storeBanner?.text} />

      <div
        className={`sticky top-0 w-full ${heroMediaType === "image" ? "h-full" : "relative"} flex justify-center z-50`}
      >
        {isCartInitialized && cart?.products?.length > 0 && (
          <Basket
            isBasketOpen={showCart}
            setCart={updateAndSaveCart}
            cartData={cart}
            updateAddedToCart={updateAddedToCart}
            handleShowCart={handleShowCart}
            store={store}
            setRefresh={() => {}}
          />
        )}
        <NavBar2
          cartActive={isCartInitialized && cart.products.length > 0}
          hideInAdvance={false}
          homeActive={true}
          storeName={heroTitle}
          handleShowCart={handleShowCart}
          store={store}
          theme={theme}
          toggleSideNav={() => setShowSideNav(!showSideNav)}
        />

        <SideNavDrawer
          isOpen={showSideNav}
          toggleDrawer={() => setShowSideNav(!showSideNav)}
          store={store}
        />
      </div>
      {heroMediaType === "image" ? (
        <Carousel
          autoPlay
          infiniteLoop
          showThumbs={false}
          showArrows={false}
          showStatus={false}
          className={cn(styles.carouselImageContainer)}
          onClickItem={() => router.push("/shop")}
        >
          {heroMediaImages.map((imageUrl) => {
            const imageName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);
            const imgurlNew = store.cohort?.includes(1)
              ? `https://ik.imagekit.io/dm2asset/dm2assetfull/${imageName}`
              : `https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/${imageName}?width=500&quality=80`;
            return (
              <div key={imageName}>
                <img src={imgurlNew} alt={imageName} className="w-full h-full object-cover pb-8" />
              </div>
            );
          })}
        </Carousel>
      ) : (
        <div className="w-full relative h-screen max-h-[90vh]" onClick={() => router.push("/shop")}>
          <ReactPlayer
            url={heroMedia}
            playing
            loop
            muted
            playsinline
            width="100%"
            height="100%"
            className={styles.carouselVideoContainer}
          />
        </div>
      )}
      <div className="w-full flex flex-col items-center mt-2.5 z-10">
        <button
          onClick={() => updateHomeActive(false)}
          className="w-36 h-10 rounded-md bg-primary text-textOnPrimary flex justify-center items-center text-sm"
        >
          SHOP NOW
        </button>
      </div>
      <div className="min-h-[400px] w-full">
        {isCollectionsLoading ? (
          <div>
            {Array(2)
              .fill(0)
              .map((_, index1) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="m-5" key={index1}>
                  <Skeleton className="w-28 h-8 mt-[50px] mb-[30px] mx-auto text-center font-bold text-primary" />
                  <div className="flex flex-row overflow-x-auto overflow-y-hidden gap-4 whitespace-nowrap hide-scrollbar">
                    {Array(2)
                      .fill(0)
                      .map((_2, i) => (
                        <SkeletonCard
                          className="m-[4px_5px_5px_4px] px-5 py-[4px] rounded-[50px] w-[10px]"
                          // eslint-disable-next-line react/no-array-index-key
                          key={i}
                          imageClass="w-[calc((var(--max-width)/1.5)-50px)] h-[calc((var(--max-width)/1.5)-50px)]"
                        />
                      ))}
                  </div>
                </div>
              ))}
          </div>
        ) : collectionsData.length > 0 ? (
          collectionsData.map((collection) => (
            <FeaturedCollectionWithProd
              cohort={store.cohort}
              key={collection.collection._id}
              collectionName={capitalizeFirstLetter(
                collection.collection.name ? collection.collection.name : "",
              )}
              productsData={collection.products}
            />
          ))
        ) : (
          <div className="h-full flex items-center justify-center">
            <p className="text-gray-500"></p>
          </div>
        )}
      </div>
    </>
  );
};

export default FeaturedHome;
